import React, { Component, Fragment } from "react";
import { DatePicker, Spin, Switch } from "antd";
import locale from "antd/lib/date-picker/locale/fr_FR";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import Periods from "../containers/PeriodsContainer";
import "./DatesPicker.css";

export const PICKER_TYPE = {
  SPECIFIC: "specific",
  INTERVAL: "interval"
};
const FootPicker = ({ onSelectPickerType, onSelectDate, pickerType, isLoading, closeModal }) => {
  function onChange(checked) {
    if (checked) {
      onSelectPickerType(PICKER_TYPE.SPECIFIC);
    } else {
      onSelectPickerType(PICKER_TYPE.INTERVAL);
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }} id="footerfooter">
      <div className="footer-picker__switch">
        <span>Période</span>
        <Switch loading={isLoading} checked={pickerType !== PICKER_TYPE.INTERVAL} onChange={onChange}></Switch>
        <span>Date spécifique</span>
      </div>
      <ul className="stats-date-side-picker">
        {pickerType === PICKER_TYPE.SPECIFIC && (
          <Fragment>
            <Spin spinning={isLoading}>
              <li
                onClick={() => {
                  onSelectDate({ endDate: moment() });
                  closeModal();
                }}
              >
                Jusqu'à aujourd'hui
              </li>
              <li
                onClick={() => {
                  onSelectDate({ endDate: moment().subtract(1, "day") });
                  closeModal();
                }}
              >
                Jusqu'à hier
              </li>
              <li
                onClick={() => {
                  onSelectDate({
                    endDate: moment()
                      .subtract(1, "weeks")
                      .endOf("week")
                  });

                  closeModal();
                }}
              >
                Jusqu'à la semaine dernière
              </li>
              <li
                onClick={() => {
                  onSelectDate({
                    endDate: moment()
                      .subtract(1, "month")
                      .endOf("month")
                  });
                  closeModal();
                }}
              >
                Jusqu'au mois dernier
              </li>
            </Spin>
          </Fragment>
        )}
        {pickerType === PICKER_TYPE.INTERVAL && (
          <Fragment>
            <Spin spinning={isLoading}>
              <li
                onClick={() => {
                  onSelectDate({ startDate: moment(), endDate: moment() });
                  closeModal();
                }}
              >
                Journée en cours
              </li>

              <li
                onClick={() => {
                  onSelectDate({ startDate: moment().startOf("week"), endDate: moment() });
                  closeModal();
                }}
              >
                Semaine en cours
              </li>
              <li
                onClick={() => {
                  onSelectDate({
                    startDate: moment()
                      .subtract(1, "weeks")
                      .startOf("week"),
                    endDate: moment()
                      .subtract(1, "weeks")
                      .endOf("week")
                  });
                  closeModal();
                }}
              >
                Semaine dernière
              </li>
              <li
                onClick={() => {
                  onSelectDate({ startDate: moment().startOf("month"), endDate: moment() });
                  closeModal();
                }}
              >
                Mois en cours
              </li>

              <li
                onClick={() => {
                  onSelectDate({
                    startDate: moment()
                      .subtract(1, "month")
                      .startOf("month"),
                    endDate: moment()
                      .subtract(1, "month")
                      .endOf("month")
                  });
                  closeModal();
                }}
              >
                Mois dernier
              </li>
              <li
                onClick={() => {
                  onSelectDate({ startDate: moment().startOf("year"), endDate: moment() });
                  closeModal();
                }}
              >
                Année en cours
              </li>
            </Spin>
          </Fragment>
        )}
      </ul>
      {pickerType === PICKER_TYPE.INTERVAL && (
        <div className="p-stats-indicator-period" style={{ marginTop: 10, width: "70%", marginLeft: 20 }}>
          {/* <div className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s">Périodes commerciales</div> */}
          <Periods />
        </div>
      )}
    </div>
  );
};

class DatesPicker extends Component {
  state = { showCalendar: false };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    const calendarPanel = document.querySelector(".ant-calendar");
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      calendarPanel &&
      !calendarPanel.contains(event.target)
    ) {
      this.setState({ showCalendar: false }, () => {
        document.removeEventListener("mousedown", this.handleClickOutside);
      });
    }
  };

  render() {
    return (
      <div
        ref={this.setWrapperRef}
        onClick={() => {
          if (!this.state.showCalendar) {
            this.setState({ showCalendar: true }, () => {
              document.addEventListener("mousedown", this.handleClickOutside);
            });
          }
        }}
      >
        {this.props.pickerType === PICKER_TYPE.INTERVAL && (
          <DatePicker.RangePicker
            value={this.props.period}
            format={"DD/MM/YYYY"}
            locale={locale}
            open={this.state.showCalendar}
            getCalendarContainer={() => document.getElementsByClassName("stats")[0]}
            renderExtraFooter={() => (
              <FootPicker
                onSelectPickerType={this.props.onSelectPickerType}
                onSelectDate={this.props.onChange}
                pickerType={PICKER_TYPE.INTERVAL}
                isLoading={this.props.isLoading}
                closeModal={() => this.setState({ showCalendar: false })}
              ></FootPicker>
            )}
            allowClear={false}
            disabledDate={this.props.disabledDate}
            onChange={(dates = []) => {
              this.setState({ showCalendar: false }, () => {
                document.removeEventListener("mousedown", this.handleClickOutside);
              });
              if (this.props.onChange) {
                this.props.onChange({ startDate: dates[0], endDate: dates[1] });
              }
            }}
            onCalendarChange={this.props.onCalendarChange}
          />
        )}
        {this.props.pickerType === PICKER_TYPE.SPECIFIC && (
          <DatePicker
            format={"DD/MM/YYYY"}
            value={Array.isArray(this.props.period) && this.props.period[1]}
            locale={locale}
            open={this.state.showCalendar}
            getCalendarContainer={() => document.getElementsByClassName("stats")[0]}
            renderExtraFooter={() => (
              <FootPicker
                onSelectPickerType={this.props.onSelectPickerType}
                onSelectDate={this.props.onChange}
                pickerType={PICKER_TYPE.SPECIFIC}
                isLoading={this.props.isLoading}
                closeModal={() => this.setState({ showCalendar: false })}
              ></FootPicker>
            )}
            disabledDate={this.props.disabledDate}
            onChange={date => {
              this.setState({ showCalendar: false }, () => {
                document.removeEventListener("mousedown", this.handleClickOutside);
              });
              if (this.props.onChange) {
                this.props.onChange({ endDate: date });
              }
            }}
          />
        )}
      </div>
    );
  }
}

DatesPicker.propTypes = {
  period: PropTypes.array,
  onChange: PropTypes.func
};

export default DatesPicker;



// WEBPACK FOOTER //
// src/modules/stats/components/DatesPicker.js